export enum ConfigLookupType {
  COMMISSION_RATE = <any>'COMMISSION_RATE',
  AUTO_PAY = <any>'AUTO_PAY',
  DEFAULT_END_DATE_PLUS_DAYS = <any>'DEFAULT_END_DATE_PLUS_DAYS',
  ALL = <any>'ALL'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/config-lookup-type.ts